import React from 'react';
import logo from '../images/evrfy_logo.svg'
import judiciaryLogo from '../images/jtt_logo_n.svg'
import eservicesLogo from '../images/eservices-logo.svg'
import jttSmall from '../images/jtt-sq.svg'


import {
  Container, Row, Col, Form, Input, Button, Navbar, Nav,
  NavbarBrand, NavLink, NavItem, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';


const Footer = ({}) => 
{
  const d = new Date();
  let year = d.getFullYear();
    

  return(
  <footer className="vrfy-footer row">
    <div style={{backgroundColor:'white'}}>
      <div className="container">
        <Row className="position-relative align-items-center">


          <div className="d-lg-flex justify-content-center">

           <div className="vrfy-logos" >
                <div className="logo-top">
                    <a href="https://eservices.ttlawcourts.org" target="_blank"><img width="209" height="35" className="logo-eservices" src={eservicesLogo} /></a>
                    <a href="/"><img className="logo-evrfy"  src={logo} /></a> 
                    <a href="https://www.ttlawcourts.org" target="_blank"><img className="logo-judiciary"  src={judiciaryLogo} /></a> 
                </div>
           </div>
            
          </div>



          
        </Row>
      </div>
    </div>

    <div style={{backgroundColor:'#022246'}}>
      <Container>


          <div className="d-flex d-flex-row lnks justify-content-center col-xs-12">

            <ul className="nav text-white">
              
              <li className="nav-item">
                <a className="nav-link" href="/about">About</a>
              </li>
              {/*
              <li className="nav-item">
                <a className="nav-link" href="/faq">FAQs</a>
              </li>
              */}

              <li className="nav-item">
                <a className="nav-link" href="/help">Help</a>
              </li>
            </ul>
            
          </div>



          <div className=" d-flex d-flex-row cavs-footer-b justify-content-center">
            {/*
            <div className="jttname">
                <p className="jtt">Judiciary of Trinidad and Tobago</p>
                <p className="appname">Court Authentication and Verification System</p>
            </div>
            */}
          </div>

          <div className="copyright">
            <div className="jtt-logo-bottom">
              <img src={jttSmall} href="/"/>
            </div>
            Copyright © {year}. <a href="https://www.ttlawcourts.org">Judiciary of Trinidad and Tobago</a>. All Rights Reserved</div>
          
        
      </Container>
    </div>
      

  </footer>
);
}
export default Footer;